import { Typography } from "@mui/material";
import MoedaText from "../ui/inputs/moedaText";
import Darf, { DarfComuns, DarfDaytrade, DarfFii } from "../../../models/darf";
import TabelaBase from "./tabelaBase";
import PercentualText from "../ui/inputs/percentualText";

type Props = {
  darf: Darf | undefined;
};

export default function TabelaDetalhes({ darf }: Props) {
  const header: {
    titulo: string;
    key: string;
    ordem: number;
    align: "left" | "center" | "right";
  }[] = [
    { titulo: "Tipo", key: "tipo", ordem: 1, align: "left" },
    { titulo: "Resultado", key: "resultado", ordem: 2, align: "right" },
    { titulo: "Compensação", key: "compensacao", ordem: 3, align: "right" },
    { titulo: "Isenção", key: "isencao", ordem: 4, align: "right" },
    {
      titulo: "Resultado Tributado",
      key: "resultadoTributado",
      ordem: 5,
      align: "right",
    },
    { titulo: "Alíquota", key: "aliquota", ordem: 6, align: "right" },
    { titulo: "Imposto", key: "imposto", ordem: 7, align: "right" },
    { titulo: "I.R.R.F.", key: "irrf", ordem: 8, align: "right" },
    { titulo: "DARF", key: "darf", ordem: 9, align: "right" },
  ];
  const rows = !darf
    ? []
    : [
        {
          tipo: celulaTipo("Comuns"),
          resultado: celularesultado(darf.operacoesComuns),
          compensacao: celulaCompensacao(darf.operacoesComuns),
          isencao: celulaIsencao(darf.operacoesComuns),
          resultadoTributado: celulaResultadoTributado(darf.operacoesComuns),
          aliquota: celulaAliquota(darf.operacoesComuns),
          imposto: celulaImposto(darf.operacoesComuns),
          irrf: celulaIrrf(darf.operacoesComuns),
          darf: celulaDarf(darf.operacoesComuns),
        },
        {
          tipo: celulaTipo("Daytrade"),
          resultado: celularesultado(darf.operacoesDaytrade),
          compensacao: celulaCompensacao(darf.operacoesDaytrade),
          isencao: celulaIsencao(darf.operacoesDaytrade),
          resultadoTributado: celulaResultadoTributado(darf.operacoesDaytrade),
          aliquota: celulaAliquota(darf.operacoesDaytrade),
          imposto: celulaImposto(darf.operacoesDaytrade),
          irrf: celulaIrrf(darf.operacoesDaytrade),
          darf: celulaDarf(darf.operacoesDaytrade),
        },
        {
          tipo: celulaTipo("FII/Fiagro"),
          resultado: celularesultado(darf.operacoesFii),
          compensacao: celulaCompensacao(darf.operacoesFii),
          isencao: celulaIsencao(darf.operacoesFii),
          resultadoTributado: celulaResultadoTributado(darf.operacoesFii),
          aliquota: celulaAliquota(darf.operacoesFii),
          imposto: celulaImposto(darf.operacoesFii),
          irrf: celulaIrrf(darf.operacoesFii),
          darf: celulaDarf(darf.operacoesFii),
        },
      ];

  const footer = !darf
    ? undefined
    : {
        tipo: celulaTipo("Total", true),
        resultado: celularesultado(darf, true),
        compensacao: celulaCompensacao(darf, true),
        isencao: celulaIsencao(darf, true),
        resultadoTributado: celulaResultadoTributado(darf, true),
        aliquota: celulaAliquota(darf, true),
        imposto: celulaImposto(darf, true),
        irrf: celulaIrrf(darf, true),
        darf: celulaDarf(darf, true),
      };

  return <TabelaBase header={header} rows={rows} footer={footer} />;

  function celulaTipo(texto: string, isFooter: boolean = false): JSX.Element {
    return celulaTexto(texto, isFooter);
  }
  function celularesultado(
    darf: DarfComuns | DarfDaytrade | DarfFii | Darf,
    isFooter: boolean = false
  ): JSX.Element {
    return celulaMoeda(darf.resultado, isFooter);
  }
  function celulaCompensacao(
    darf: DarfComuns | DarfDaytrade | DarfFii | Darf,
    isFooter: boolean = false
  ): JSX.Element {
    return celulaMoeda(darf.prejuizoCompensado, isFooter);
  }
  function celulaIsencao(
    darf: DarfComuns | DarfDaytrade | DarfFii | Darf,
    isFooter: boolean = false
  ): JSX.Element {
    return celulaMoeda((darf as Darf).resultadoIsento, isFooter);
  }
  function celulaResultadoTributado(
    darf: DarfComuns | DarfDaytrade | DarfFii | Darf,
    isFooter: boolean = false
  ): JSX.Element {
    return celulaMoeda(darf.resultadoTributado, isFooter);
  }
  function celulaAliquota(
    darf: DarfComuns | DarfDaytrade | DarfFii | Darf,
    isFooter: boolean = false
  ): JSX.Element {
    return celulaPercentual(
      darf.impostoTributado / darf.resultadoTributado,
      isFooter
    );
  }
  function celulaImposto(
    darf: DarfComuns | DarfDaytrade | DarfFii | Darf,
    isFooter: boolean = false
  ): JSX.Element {
    return celulaMoeda(darf.impostoTributado, isFooter);
  }
  function celulaIrrf(
    darf: DarfComuns | DarfDaytrade | DarfFii | Darf,
    isFooter: boolean = false
  ): JSX.Element {
    return celulaMoeda(darf.irrfCompensado, isFooter);
  }
  function celulaDarf(
    darf: DarfComuns | DarfDaytrade | DarfFii | Darf,
    isFooter: boolean = false
  ): JSX.Element {
    return celulaMoeda(darf.impostoDevido, isFooter);
  }

  function celulaTexto(texto: string, _isFooter: boolean): JSX.Element {
    return <Typography>{texto}</Typography>;
  }

  function celulaMoeda(valor: number, _isFooter: boolean): JSX.Element {
    return (
      <Typography variant="dataMono">
        <MoedaText displayType={"text"} value={valor}></MoedaText>
      </Typography>
    );
  }

  function celulaPercentual(valor: number, _isFooter: boolean): JSX.Element {
    return (
      <Typography variant="dataMono">
        <PercentualText displayType={"text"} value={valor}></PercentualText>
      </Typography>
    );
  }
}
